import { axios } from '@/utils/request'

export function sendIndustrialTourism(formData) {
    return axios({
        url: '/forms/industrial-tourism/',
        method: 'POST',
        data: formData
    })
}
